export default "__VITE_ASSET__DpI7_aPw__"